import * as _ from "lodash";

export class ActionConfigPreparation
{
    static presets = {
        new: {
            type: 'view',
            icon: 'fa fa-plus',
            actionClass: 'tw-btn-success btn-sm',
            label: 'label.new',
            showLabel: false,
            modal: true,
            name: 'create'
        },
        edit: {
            type: 'view',
            icon: 'fa fa-pencil',
            style: 'primary',
            label: 'label.edit',
            showLabel: false,
            name: 'edit'
        },
        display: {
            type: 'view',
            //Todo better search icon
            icon: 'fa fa-share',
            style: 'primary',
            label: 'label.display',
            showLabel: false,
            name: 'display'
        },
        pencil: {
            type: 'view',
            icon: 'fa fa-pencil',
            actionClass: 'btn btn-link pull-right',
            label: 'label.edit',
            showLabel: false,
            name: 'pencil',
            modal: true
        },
        delete: {
            type: 'delete',
            icon: 'fa fa-trash',
            style: 'danger',
            label: 'label.delete',
            showLabel: false,
            name: 'delete'
        },
        archive: {
            type: 'archive',
            icon: 'fa fa-box',
            style: 'warning',
            label: 'action.archive',
            showLabel: true,
            name: 'archive'
        },
        unarchive: {
            type: 'archive',
            icon: 'fa fa-box-open',
            style: 'warning',
            label: 'action.unarchive',
            showLabel: true,
            name: 'unarchive'
        }
    };

    static styleMap = {
        primary: 'tw-btn-primary',
        success: 'tw-btn-success',
        warning: 'tw-btn-warning',
        danger: 'tw-btn-danger',
    }

    /*public*/ static prepare(config)
    {
        config = _.cloneDeep(config);

        if (config.preset && ActionConfigPreparation.presets[config.preset] != null) {
            config = Object.assign({}, ActionConfigPreparation.presets[config.preset], config);
        }

        if (config.style != null) {
            config.buttonClass = ActionConfigPreparation.styleMap[config.style] ?? 'tw-btn-default';
        }

        if (config.actionClass !== undefined) {
            config.buttonClass = config.actionClass;
        }

        return config;
    }
}
